export const IconTrustStar = ({
  width = '20',
  height = '20',
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect width='20' height='20' fill='#00B67A' />
    <g transform='translate(1, 0.5)'>
      {' '}
      {/* Centering Fix */}
      <path
        d='M9 12.6761L12.0417 11.8616L13.3125 16L9 12.6761ZM16 7.32704H10.6458L9 2L7.35417 7.32704H2L6.33334 10.6289L4.6875 15.956L9.0208 12.6541L11.6875 10.6289L16 7.32704Z'
        fill='#FAFAFC'
      />
    </g>
  </svg>
);
